import styled from 'styled-components';

const AuthStyledContainer = styled.div``;

export default AuthStyledContainer;
